<template>
  <v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card v-if="store_data != null">
      <!-- {{store_data}} -->
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">New Store</v-toolbar-title>
        <v-spacer />
        <v-icon @click="closeDialog()">close</v-icon>
      </v-toolbar>
      <!-- {{store_data}} -->
      <v-card-text style="height: auto; padding: 0px">
        <v-stepper non-linear alt-labels v-model="e1">
          <v-stepper-header>
            <v-stepper-step
              :editable="false"
              step="1"
              style="padding-bottom: 3px; padding: 10px"
              >Store Information</v-stepper-step
            >
            <v-divider />
            <v-stepper-step
              :editable="false"
              step="2"
              style="padding-bottom: 3px; padding: 10px"
              >Store Images</v-stepper-step
            >
            <v-divider />
            <v-stepper-step
              :editable="false"
              step="3"
              style="padding-bottom: 3px; padding: 10px"
              >Store Address</v-stepper-step
            >
            <v-divider />
            <v-stepper-step
              :editable="false"
              step="4"
              style="padding-bottom: 3px; padding: 10px"
              >Store Open/Close</v-stepper-step
            >
            <v-divider />
            <v-stepper-step step="5" style="padding-bottom: 3px; padding: 10px"
              >Special Open/Close</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" style="padding: 0px">
              <section id="sec01">
                <v-tabs v-model="tabs" grow light color="primary">
                  <v-tabs-slider color="black"></v-tabs-slider>
                  <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
                </v-tabs>
                <v-card-text style="height: auto">
                  <v-form ref="formStoreInformation" v-model="valid">
                    <v-tabs-items v-model="tabs">
                      <v-tab-item v-for="n in lang" :key="n">
                        <div style="padding: 1px; background-color: #eeeeee">
                          <v-layout row wrap>
                            <v-flex xs12 sm6 class="px-2">
                              <!-- <v-text-field
                                v-model="store_data['store_name_'+ n.toLowerCase()]"
                                :label="'Store name ' + '(' + n +')'"
                                :hint="n == 'CN' ? '' : 'Required'"
                                persistent-hint
                                :rules="n == 'TH' || n == 'EN' ? [v => !!v || 'name is required'] : [v => true || '']"
                              ></v-text-field>-->
                              <v-text-field
                                v-if="n === 'EN'"
                                @input="upperEn($event)"
                                v-model="store_data.store_name_en"
                                :label="'Store name ' + '(' + n + ')'"
                                persistent-hint
                                :rules="
                                  store_data.store_name_en
                                    ? [rules.required, rules.max]
                                    : [rules.required]
                                "
                                counter="55"
                              ></v-text-field>
                              <v-text-field
                                v-else-if="n === 'TH'"
                                @input="upperTh($event)"
                                v-model="store_data.store_name_th"
                                :label="'Store name ' + '(' + n + ')'"
                                persistent-hint
                                :rules="
                                  store_data.store_name_th
                                    ? [rules.required, rules.max]
                                    : [rules.required]
                                "
                                counter="55"
                              ></v-text-field>
                              <v-text-field
                                v-else
                                @input="upperCn($event)"
                                v-model="store_data.store_name_cn"
                                :label="'Store name ' + '(' + n + ')'"
                                persistent-hint
                                :rules="
                                  store_data.store_name_cn ? [rules.max] : []
                                "
                                counter="55"
                              ></v-text-field>
                              <v-select
                                @change="
                                  selectServices(
                                    store_data.store_store_service_id
                                  )
                                "
                                v-model="store_data.store_store_service_id"
                                :items="store_services"
                                item-value="store_service_id"
                                item-text="store_service_name_th"
                                label="Store service"
                                style="margin-top: 9px"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 class="px-2">
                              <v-textarea
                                v-model="
                                  store_data[
                                    'store_description_' + n.toLowerCase()
                                  ]
                                "
                                name="description"
                                :label="'Description ' + '(' + n + ')'"
                                value
                                rows="5"
                                :rules="
                                  store_data[
                                    'store_description_' + n.toLowerCase()
                                  ]
                                    ? [rules.max_description]
                                    : []
                                "
                                counter="255"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                    <!-- select type chip -->
                    <v-select
                      v-model="store_data.store_type"
                      :items="types"
                      :rules="[
                        (v) => v.length != 0 || 'กรุณาเลือก Store service ก่อน',
                      ]"
                      item-text="store_type_name_th"
                      item-value="store_type_id"
                      chips
                      label="Store type"
                      multiple
                      class="px-1"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          @input="remove(data.item, data.index)"
                        >
                          <span>{{ data.item.store_type_name_th }}</span>
                        </v-chip>
                      </template>
                    </v-select>

                    <!-- END select type chip -->

                    <v-layout row wrap>
                      <v-flex xs6 class="px-1">
                        <v-select
                          v-model="store_data.store_active"
                          :items="storestatusItems"
                          item-text="name"
                          item-value="value"
                          label="Store status"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6 class="px-1">
                        <v-select
                          :items="packageItems"
                          v-model="store_data.store_package_id"
                          item-text="package_name"
                          item-value="package_id"
                          label="Package"
                          :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                    <!-- <div style="position:relative;">
                      <label
                        style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                      >Price range :</label>
                    </div>-->
                    <v-layout row wrap>
                      <!-- <v-flex xs12 sm2 style="position:relative;">
                          <label
                            style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                          >Price range :</label>
                      </v-flex>-->
                      <v-flex xs12 md6 class="px-1">
                        <v-layout row wrap justify-start>
                          <v-flex xs3 style="position: relative">
                            <label class="price_range">Price range :</label>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              mask="######"
                              :rules="[rules.required, rules.onlyNumber]"
                              solo
                              v-model.number="
                                store_data.store_price_range_start
                              "
                              placeholder="Min price"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 class="text-xs-center py-2">
                            <v-icon small>remove</v-icon>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              mask="######"
                              :rules="[rules.required, rules.onlyNumber]"
                              solo
                              v-model.number="store_data.store_price_range_end"
                              placeholder="Max price"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6 sm6 md6 class="px-1">
                        <v-text-field
                          :rules="[rules.onlyNumber]"
                          v-model.number="store_data.store_vat"
                          label="VAT"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 sm6 md6 class="px-1">
                        <v-text-field
                          :rules="[rules.onlyNumber]"
                          v-model.number="store_data.store_service_charge"
                          label="Service charge"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 class="px-1">
                        <div
                          v-for="(info, index) in store_data.store_email"
                          :key="index"
                          style="display: flex; align-items: center"
                        >
                          <v-text-field
                            type="text"
                            v-model="info.email"
                            :label="`Email ${index + 1}`"
                            :rules="[rules.required, rules.email]"
                          ></v-text-field>
                          <v-btn
                            icon
                            color="green"
                            v-if="index == 0"
                            @click="store_data.store_email.push({ email: '' })"
                            ><v-icon style="color: white">add</v-icon></v-btn
                          >
                          <v-btn
                            icon
                            color="red"
                            v-else
                            @click="store_data.store_email.splice(index, 1)"
                            ><v-icon style="color: white">remove</v-icon></v-btn
                          >
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        v-for="(info, index) in store_data.store_tel"
                        :key="index"
                      >
                        <v-layout row align-center class="text-xs-center">
                          <v-flex xs10 class="px-1">
                            <v-text-field
                              mask="###-#######"
                              v-model="info.tel"
                              :label="'Tel.' + (index + 1) + ' : '"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 class="px-1">
                            <v-btn
                              icon
                              small
                              color="green"
                              v-if="index == 0"
                              @click="store_data.store_tel.push({ tel: '' })"
                            >
                              <v-icon color="white">add</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              small
                              color="red"
                              v-else
                              @click="store_data.store_tel.splice(index, 1)"
                            >
                              <v-icon color="white">remove</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer />
                  <v-btn flat color="red" @click="closeDialog()">Cancel</v-btn>
                  <v-btn color="primary" class="black--text" @click="toE2()"
                    >Continue</v-btn
                  >
                </v-card-actions>
              </section>
            </v-stepper-content>

            <v-stepper-content step="2" style="padding: 0px">
              <input
                style="display: none"
                type="file"
                @change="onLogoSelected"
                ref="LogoInput"
                accept="image/*"
              />
              <v-layout justify-center>
                <component
                  :is="componentsImageID"
                  :logoSrc="logoSrc"
                  @toE3="e1 = 3"
                  :store_data="store_data"
                  :selectedFile="selectedFile"
                  @changeComponents="componentsImageID = $event"
                  @getCroped="croppedLogo($event)"
                  @closeDialog="e1 = e1 - 1"
                  @selectImage="$refs.LogoInput.click()"
                ></component>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step="3" style="padding: 0px">
              <section id="sec02">
                <v-card>
                  <v-tabs v-model="tabs_address" grow light color="primary">
                    <v-tabs-slider color="black"></v-tabs-slider>
                    <v-tab v-for="item in lang_address" :key="item">{{
                      item
                    }}</v-tab>
                  </v-tabs>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 class="px-1">
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-tabs-items v-model="tabs_address">
                            <v-tab-item v-for="n in lang_address" :key="n">
                              <div style="padding-top: 1px">
                                <v-textarea
                                  v-model="
                                    store_data[
                                      'store_address_' + n.toLowerCase()
                                    ]
                                  "
                                  name="address"
                                  :label="'Address (' + n.toUpperCase() + ')'"
                                  value
                                  hint="Hint text"
                                  rows="5"
                                ></v-textarea>
                              </div>
                            </v-tab-item>
                          </v-tabs-items>
                          <v-layout row wrap>
                            <v-flex xs6 class="px-1">
                              <v-select
                                :loading="
                                  fetching_data == true ? 'black' : false
                                "
                                :disabled="fetching_data"
                                v-model="store_data.store_province_id"
                                @change="getDistrict"
                                :items="provinceItems"
                                item-value="province_id"
                                item-text="province_name_th"
                                label="Province"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-flex>
                            <v-flex xs6 class="px-1">
                              <v-select
                                v-model="store_data.store_district_id"
                                @change="getSubDistrictAndZipCode"
                                :items="districtItems"
                                item-value="district_id"
                                item-text="district_name_th"
                                label="District"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6 class="px-1">
                              <v-select
                                v-model="store_data.store_sub_district_id"
                                :items="subDistrictItems"
                                item-value="sub_district_id"
                                item-text="sub_district_name_th"
                                label="Sub district"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-flex>
                            <v-flex xs6 class="px-1">
                              <v-select
                                v-model="store_data.store_zipcode_id"
                                :items="postcodeItems"
                                item-value="zipcode_id"
                                item-text="zipcode_code"
                                label="Post Code"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                          <v-textarea
                            v-model="store_data.store_note"
                            name="note"
                            label="Place Note"
                            value
                            rows="1"
                          ></v-textarea>
                          <v-layout row wrap>
                            <v-flex xs6 class="px-1">
                              <v-text-field
                                v-model="store_data.store_lat"
                                :rules="[rules.required, rules.onlyDouble]"
                                label="Latitude"
                                placeholder="0.000000"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6 class="px-1">
                              <v-text-field
                                v-model="store_data.store_long"
                                :rules="[rules.required, rules.onlyDouble]"
                                label="Longitude"
                                placeholder="0.000000"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-btn @click="change++">update Location</v-btn>
                        </v-form>
                      </v-flex>
                      <v-flex xs12 sm6 class="px-1">
                        <v-card height="400px" width="auto" color="white">
                          <GoogleMap
                            :latitude="parseFloat(store_data.store_lat)"
                            :longitude="parseFloat(store_data.store_long)"
                            :change="change"
                            :height="400"
                            :zoom="15"
                            :mapType="'all'"
                            :draggable="true"
                            @draged="getDragLocation($event)"
                          ></GoogleMap>
                        </v-card>
                        <!-- <v-card height="400px" width="auto" color="grey">Pin location ( not yet )</v-card> -->
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn flat color="red" @click="e1 = e1 - 1">Back</v-btn>
                    <v-btn color="primary" class="black--text" @click="toE4()"
                      >Continue</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </section>
            </v-stepper-content>
            <v-stepper-content step="4" style="padding: 0px">
              <section id="sec03">
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <!-- Daily -->
                      <v-flex xs12 md6 class="pl-4">
                        <strong class="pl-2">Daily Close/Open</strong>
                        <section
                          id="subsec01"
                          v-for="item in timeItems"
                          :key="item.days"
                        >
                          <v-layout row justify-start>
                            <v-flex
                              xs1
                              style="margin-top: 20px; text-align: center"
                            >
                              <!-- <v-checkbox :label="item.days" v-model="checkbox" :value="item.value" color="green"></v-checkbox> -->
                              <span>{{ item.days }}</span>
                            </v-flex>
                            <v-flex xs4 class="text-xs-center">
                              <vue-timepicker
                                @change="selectedTimeOpen($event, item.days)"
                                format="HH:mm"
                                :minute-interval="15"
                                class="timePicker innerstore-timepicker"
                                v-if="dialog == true"
                              ></vue-timepicker>
                            </v-flex>
                            <v-flex
                              xs1
                              style="margin-top: 20px; text-align: center"
                            >
                              <span>to</span>
                            </v-flex>
                            <v-flex xs4 class="text-xs-center">
                              <vue-timepicker
                                @change="selectedTimeClose($event, item.days)"
                                :minute-interval="15"
                                class="timePicker innerstore-timepicker"
                                v-if="dialog == true"
                              ></vue-timepicker>
                            </v-flex>
                            <v-flex xs1>
                              <v-icon
                                large
                                class="mt-3"
                                color="green"
                                @click="item.more = true"
                                >add_box</v-icon
                              >
                            </v-flex>
                          </v-layout>
                          <v-layout row justify-start v-if="item.more">
                            <v-flex xs1></v-flex>
                            <v-flex xs4 class="text-xs-center">
                              <vue-timepicker
                                @change="selectedTimeOpen2($event, item.days)"
                                :minute-interval="15"
                                class="timePicker innerstore-timepicker"
                                v-if="dialog == true"
                              ></vue-timepicker>
                            </v-flex>
                            <v-flex
                              xs1
                              style="margin-top: 20px; text-align: center"
                            >
                              <span>to</span>
                            </v-flex>
                            <v-flex xs4 class="text-xs-center">
                              <vue-timepicker
                                @change="selectedTimeClose2($event, item.days)"
                                :minute-interval="15"
                                class="timePicker innerstore-timepicker"
                                v-if="dialog == true"
                              ></vue-timepicker>
                            </v-flex>
                            <v-flex xs1>
                              <v-icon
                                large
                                class="mt-3"
                                color="red"
                                @click="indeterminateTime(item)"
                                >indeterminate_check_box</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </section>
                        <!--End-เมื่อกดเพิ่มช่วงเวลาเปิดปิดร้าน -->
                      </v-flex>
                      <!-- End-Daily -->
                      <!-- Special -->
                      <v-flex xs12 md6>
                        <div>
                          <br class="hidden-md-and-up" />
                          <strong class="pl-4">Pre Order</strong>
                          <v-layout row wrap justify-center>
                            <v-flex xs4 md4>
                              <v-radio-group
                                v-model="preOrderGroup"
                                class="pl-2"
                              >
                                <v-radio
                                  color="black"
                                  label="No"
                                  value="0"
                                  style="margin-bottom: 21px"
                                ></v-radio>
                                <v-radio
                                  color="black"
                                  label="Delivery in"
                                  value="1"
                                  style="margin-bottom: 21px"
                                ></v-radio>
                                <v-radio
                                  color="black"
                                  label="Delivery in"
                                  value="2"
                                  style="margin-bottom: 21px"
                                ></v-radio>
                                <v-radio
                                  color="black"
                                  label="Delivery at"
                                  value="3"
                                  style="margin-bottom: 21px"
                                ></v-radio>
                                <div
                                  style="
                                    padding-left: 80px;
                                    padding-top: 10px;
                                    color: rgba(0, 0, 0, 0.54);
                                  "
                                >
                                  and
                                </div>
                                <div
                                  style="
                                    padding-left: 80px;
                                    padding-top: 25px;
                                    color: rgba(0, 0, 0, 0.54);
                                  "
                                >
                                  and
                                </div>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs5 md4>
                              <div style="margin-bottom: 45px"></div>
                              <vue-timepicker
                                :minute-interval="15"
                                class="timePicker innerstore-timepicker"
                                format="HH:mm"
                                @change="selectTimePreorder($event)"
                                v-if="dialog == true"
                              ></vue-timepicker>
                              <v-select
                                outline
                                :items="number"
                                v-model="
                                  store_time_preorder.store_time_preorder_day
                                "
                                menu-props="auto"
                                placeholder="Select date"
                                hide-details
                                style="margin-top: 15px; width: 130px"
                              ></v-select>
                              <v-select
                                outline
                                :items="days"
                                v-model="
                                  store_time_preorder
                                    .store_time_preorder_daytime[0]
                                "
                                menu-props="auto"
                                placeholder="Select day"
                                hide-details
                                style="margin-top: 15px; width: 130px"
                              ></v-select>
                              <v-select
                                outline
                                :items="days"
                                v-model="
                                  store_time_preorder
                                    .store_time_preorder_daytime[1]
                                "
                                menu-props="auto"
                                placeholder="Select day"
                                hide-details
                                style="margin-top: 15px; width: 130px"
                              ></v-select>
                              <v-select
                                outline
                                :items="days"
                                v-model="
                                  store_time_preorder
                                    .store_time_preorder_daytime[2]
                                "
                                menu-props="auto"
                                placeholder="Select day"
                                hide-details
                                style="margin-top: 15px; width: 130px"
                              ></v-select>
                            </v-flex>
                            <v-flex xs2 md2>
                              <div style="margin-bottom: 45px"></div>
                              <div
                                style="
                                  padding-top: 22px;
                                  color: rgba(0, 0, 0, 0.54);
                                "
                              >
                                Hour
                              </div>
                              <div
                                style="
                                  padding-top: 27px;
                                  color: rgba(0, 0, 0, 0.54);
                                "
                              >
                                Day
                              </div>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <!-- End-Special -->
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      flat
                      color="red"
                      :disabled="adding_store"
                      @click="e1 = e1 - 1"
                      >Back</v-btn
                    >
                    <v-btn
                      :loading="adding_store"
                      :disabled="adding_store || isEditStoreList"
                      color="green"
                      class="black--text"
                      @click="completed()"
                      >save</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </section>
            </v-stepper-content>
            <v-stepper-content step="5" style="padding: 0px">
              <section id="sec04">
                <v-card>
                  <v-card-text class="text-xs-center">
                    <v-icon large color="green">check_circle</v-icon>
                    <h1>Create store completed.</h1>
                    <h4>You can add special close/open or skip it!</h4>
                    <v-btn
                      round
                      @click="addSpecial()"
                      :disabled="isEditStoreList"
                      v-if="open_special_form != true"
                    >
                      <v-icon>add</v-icon>&nbsp;&nbsp;special close/open
                    </v-btn>
                  </v-card-text>

                  <v-card-text>
                    <!-- Special -->
                    <strong class="pl-2">Special Close/Open</strong>
                    <specialTimeForm
                      :store_add_id="store_add_id"
                      v-if="open_special_form == true"
                      @resetForm="setForm()"
                      :form="form"
                      @save="saveAdd()"
                      @cancel="cancelAdd()"
                    />
                    <div style="height: 380px; overflow-y: auto">
                      <!-- <v-btn absolute dark
                            fab
                            top
                            right
                            small
                            color="primary"
                            style="top:10px;"
                            @click="open_special_form = true"
                          >
                            <v-icon color="black">add</v-icon>
                      </v-btn>-->
                      <v-data-table
                        :headers="headers"
                        :items="store_detail.store_close"
                        hide-actions
                        class="head-time"
                        v-if="store_detail != null"
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center" style="padding: 15px">
                            {{ props.item.store_close_date }}
                          </td>
                          <td class="text-xs-center" style="padding-right: 0">
                            {{ props.item.store_close_msg }}
                          </td>
                          <td class="text-xs-left" style="padding-right: 0">
                            {{ props.item.store_close_note }}
                          </td>
                          <td
                            class="text-xs-center"
                            style="padding: 0; width: 105px"
                          >
                            <v-btn icon @click="delSpecial(props.item)">
                              <v-icon small>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>

                        <template slot="no-data">
                          <center>
                            <h3>ไม่มีวันหยุดพิเศษ</h3>
                          </center>
                        </template>
                      </v-data-table>
                    </div>
                    <!-- End-Special -->
                  </v-card-text>
                  <v-divider></v-divider>
                </v-card>
              </section>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState, mapGetters } from "vuex";
import specialTimeForm from "./NewSpecialTimeForm";
import imageCropper from "./ImageCropper.vue";
import imageUploader from "./ImageUploader.vue";
export default {
  props: ["dialog", "store_data", "fetching_data"],
  components: {
    VueTimepicker,
    specialTimeForm,
    imageCropper,
    imageUploader,
  },
  data() {
    return {
      store_add_id: null,
      rules: {
        onlyDouble: (value) => {
          const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
          return pattern.test(value) || "Invalid";
        },
        required: (value) => !!value || "Required.",
        min: (value) => value.length >= 8 || "Minimum length is 8 characters.",
        max: (value) =>
          value.length <= 55 || "Maximum length is 55 characters.",
        max_description: (value) =>
          value.length <= 255 || "Maximum length is 255 characters.",
        onlyNumber: (value) =>
          /^[0-9+.]*$/.test(value) || "only numbers are allowed.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        upper: (value) => /^[A-Z]*$/.test(value) || "Upper characters.",
      },
      change: 0,
      logoSrc: "",
      componentsImageID: "imageUploader",
      adding_store: false,
      change_image: 0,
      form: {},
      store_time_preorder: {
        store_time_preorder_daytime: [],
        store_time_preorder_day: null,
        store_time_preorder_time: null,
      },
      testtime: null,
      open_special_form: false,
      selectedFile: {
        logo_name: "",
        banner_name: "",
      },
      types: [],
      e1: 0,
      valid: true,
      storename: "",
      // storeserviceItems: [
      //   {
      //     name: "ร้านอาหาร",
      //     value: 1
      //   }
      // ],
      // storetypeItems: [
      //   {
      //     name: "อาหารไทย",
      //     value: 1
      //   },
      //   {
      //     name: "อาหารจานเดียว",
      //     value: 2
      //   }
      // ],
      storestatusItems: [
        {
          name: "Active",
          value: true,
        },
        {
          name: "Inactive",
          value: false,
        },
      ],
      minprice: "",
      maxprice: "",
      servicecharge: "",
      vat: "",
      country_tel: ["+66"],
      email: "",
      tabs: 0,
      tabs_address: 0,
      lang: ["TH", "EN", "CN"],
      lang_address: ["TH", "EN", "CN"],
      chips: "",
      checkbox: [],
      timeItems: [
        {
          days: "Mon",
          more: false,
        },
        {
          days: "Tue",
          more: false,
        },
        {
          days: "Wed",
          more: false,
        },
        {
          days: "Thu",
          more: false,
        },
        {
          days: "Fri",
          more: false,
        },
        {
          days: "Sat",
          more: false,
        },
        {
          days: "Sun",
          more: false,
        },
      ],
      headers: [
        {
          text: "Date",
          align: "center",
          value: "store_close_date",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "store_close_msg",
          sortable: false,
        },
        {
          text: "Note",
          align: "center",
          value: "store_close_note",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
      bannerdate1: new Date().toISOString().substr(0, 10),
      bannerdate2: new Date().toISOString().substr(0, 10),
      bannermenu1: false,
      bannermenu2: false,
      preOrderGroup: "0",
      day: null,
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      num: null,
      number: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    };
  },
  computed: {
    ...mapState({
      customer_only_list: (state) => state.fetchCustomerBack.customer_only_list,
      store_services: (state) => state.fetchStoreBack.store_type.store_services,
      store_types: (state) => state.fetchStoreBack.store_type.store_types,
      provinceItems: (state) => state.fetchProvinceBack.province_list,
      districtItems: (state) => state.fetchProvinceBack.district_list,
      subDistrictItems: (state) => state.fetchProvinceBack.sub_district_list,
      postcodeItems: (state) => state.fetchProvinceBack.zip_code_list,
      packageItems: (state) => state.fetchPackageBack.package_data,
      store_detail: (state) => state.fetchStoreBack.store_detail,
      store_list: (state) => state.fetchStoreBack.store_list,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    upperEn(val) {
      this.store_data.store_name_en = val.toUpperCase();
    },
    upperTh(val) {
      this.store_data.store_name_th = val.toUpperCase();
    },
    upperCn(val) {
      this.store_data.store_name_cn = val.toUpperCase();
    },
    getDragLocation(val) {
      this.store_data.store_lat = val.lat;
      this.store_data.store_long = val.lng;
    },
    toE2() {
      if (this.$refs.formStoreInformation.validate()) {
        this.e1 = 2;
      } else {
        if (
          this.store_data.store_name_th == "" ||
          this.store_data.store_name_th == null
        ) {
          this.tabs = 0;
        }
      }
    },
    toE4() {
      if (this.$refs.form.validate()) {
        this.e1 = 4;
      }
    },
    delSpecial(data) {
      this.$store.dispatch("fetchStoreBack/delSpecialTime", data);
    },
    setForm() {
      this.form = {
        store_close_pattern_weekday: null,
        store_close_pattern_weeknum: null,
        store_close_type: null,
        store_close_note: null,
        store_close_period: null,
        store_close_date_start: null,
        store_close_date_end: null,
        store_close_date: null,
        store_close_store_id: null,
      };
    },
    addSpecial() {
      this.open_special_form = true;
      this.setForm();
    },
    saveAdd() {
      this.setForm();
      // this.open_special_form = false;
    },
    cancelAdd() {
      this.open_special_form = false;
    },
    closeDialog() {
      this.preOrderGroup = "0";
      this.store_time_preorder = {
        store_time_preorder_daytime: [],
        store_time_preorder_day: null,
        store_time_preorder_time: null,
      };
      this.selectedFile = {
        logo_name: "",
        banner_name: "",
      };
      this.$emit("close");
      this.e1 = 1;
    },
    stringEmptyToNull(form) {
      for (let val in form) {
        if (typeof form[val] == "string" && form[val] == "") {
          form[val] = null;
        }
        if (typeof form[val] == "object" && form[val] != null) {
          for (let arr in form[val]) {
            for (let val1 in form[val][arr]) {
              if (
                typeof form[val][arr][val1] == "string" &&
                form[val][arr][val1] == ""
              ) {
                form[val][arr][val1] = null;
              }
              if (
                typeof form[val][arr][val1] == "object" &&
                form[val][arr][val1] != null
              ) {
                for (let arr2 in form[val][arr][val1]) {
                  for (let val2 in form[val][arr][val1][arr2]) {
                    if (
                      typeof form[val][arr][val1][arr2][val2] == "string" &&
                      form[val][arr][val1][arr2][val2] == ""
                    )
                      form[val][arr][val1][arr2][val2] = null;
                  }
                }
              }
            }
          }
        }
      }
      return form;
    },
    async completed() {
      if (!this.validateTime())
        return alert(
          "กรุณากรอกเวลาเปิด - ปิดร้านอย่างน้อย 1 ช่วงเวลา หรือ ช่วงเวลาไม่ครบถ้วน"
        );
      if (
        this.$refs.form.validate() &&
        this.$refs.formStoreInformation.validate()
      ) {
        this.store_data.store_time.store_time_preorder_daytime = null;
        this.store_data.store_time.store_time_preorder_day = null;
        this.store_data.store_time.store_time_preorder_time = null;
        if (this.preOrderGroup == 1) {
          this.store_data.store_time.store_time_preorder_time = this.store_time_preorder.store_time_preorder_time;
        } else if (this.preOrderGroup == 2) {
          this.store_data.store_time.store_time_preorder_day = this.store_time_preorder.store_time_preorder_day;
        } else if (this.preOrderGroup == 3) {
          let a = {
            store_time_preorder_daytime: [],
          };
          for (let key in this.store_time_preorder
            .store_time_preorder_daytime) {
            a.store_time_preorder_daytime.push(
              this.store_time_preorder.store_time_preorder_daytime[key]
            );
          }
          this.store_data.store_time.store_time_preorder_daytime =
            a.store_time_preorder_daytime;
        }
        if (this.store_data.store_service_charge != 0) {
          if (
            this.store_data.store_service_charge == null ||
            this.store_data.store_service_charge == ""
          ) {
            delete this.store_data.store_service_charge;
          }
        }
        if (this.store_data.store_vat != 0) {
          if (
            this.store_data.store_vat == null ||
            this.store_data.store_vat == ""
          ) {
            delete this.store_data.store_vat;
          }
        }
        if (this.change_image == 0) {
          delete this.store_data.store_image;
        }
        if (
          this.store_data.store_user_id == null ||
          this.store_data.store_use_pos != 2
        ) {
          delete this.store_data.store_user_id;
        }

        for (let x in this.store_data) {
          if (this.store_data[x] != 0) {
            if (this.store_data[x] == "" || this.store_data[x] == null) {
              delete this.store_data[x];
            }
          }
        }

        this.adding_store = true;
        let copy_store_data = JSON.parse(JSON.stringify(this.store_data));
        delete copy_store_data.store_active_name;
        copy_store_data = await this.stringEmptyToNull(copy_store_data);
        let stringEmail = "";
        for (let key in copy_store_data.store_email) {
          stringEmail = stringEmail + copy_store_data.store_email[key].email;
          if (key != copy_store_data.store_email.length - 1) {
            stringEmail = stringEmail + ",";
          }
        }

        copy_store_data.store_email = stringEmail;
        let check_success = await this.$store.dispatch(
          "fetchStoreBack/addStoreList",
          copy_store_data
        );

        if (check_success.msg == 0) {
          alert("Tel. already in use");
        } else if (check_success.msg == 1) {
          alert("Email already in use");
        } else if (check_success == 99 && !check_success.msg) {
          alert("ไม่สามารถสร้างร้านค้าได้");
        } else {
          await this.$store.dispatch(
            "fetchStoreBack/getStoreDetailAdd",
            check_success.store_id
          );

          this.e1 = 5;

          this.preOrderGroup = "0";
          this.store_add_id = check_success.store_id;
          this.store_time_preorder = {
            store_time_preorder_daytime: [],
            store_time_preorder_day: null,
            store_time_preorder_time: null,
          };
        }
        this.adding_store = false;
      }
    },
    validateTime() {
      let count_match = 0;
      let count_open = [];
      let count_close = [];
      for (let val in this.store_data.store_time) {
        if (
          val.split("_")[2] == "open" &&
          this.store_data.store_time[val] != null
        ) {
          count_open.push(val.split("_")[3]);
        }
        if (
          val.split("_")[2] == "close" &&
          this.store_data.store_time[val] != null
        ) {
          count_close.push(val.split("_")[3]);
        }
      }
      for (let val of count_open) {
        for (let val2 of count_close) {
          if (val == val2) {
            count_match++;
          }
        }
      }
      if (
        count_match == 0 ||
        count_open.length != count_match ||
        count_close.length != count_match
      ) {
        return false;
      } else {
        return true;
      }
    },
    selectTimePreorder(value) {
      this.store_time_preorder.store_time_preorder_time =
        value.data.HH + ":" + value.data.mm;
      if (value.data.HH == "" && value.data.mm == "") {
        this.store_time_preorder.store_time_preorder_time = "";
      }
    },
    indeterminateTime(item) {
      item.more = false;
      this.store_data.store_time[
        "store_time_open_" + item.days.toLowerCase() + "2"
      ] = null;
      this.store_data.store_time[
        "store_time_close_" + item.days.toLowerCase() + "2"
      ] = null;
    },
    selectedTimeOpen(value, days) {
      this.store_data.store_time["store_time_open_" + days.toLowerCase()] =
        value.data.HH + ":" + value.data.mm + ":00";
      if (value.data.HH == "" || value.data.mm == "") {
        this.store_data.store_time[
          "store_time_open_" + days.toLowerCase()
        ] = null;
      }
    },
    selectedTimeClose(value, days) {
      this.store_data.store_time["store_time_close_" + days.toLowerCase()] =
        value.data.HH + ":" + value.data.mm + ":00";
      if (value.data.HH == "" || value.data.mm == "") {
        this.store_data.store_time[
          "store_time_close_" + days.toLowerCase()
        ] = null;
      }
    },
    selectedTimeOpen2(value, days) {
      this.store_data.store_time[
        "store_time_open_" + days.toLowerCase() + "2"
      ] = value.data.HH + ":" + value.data.mm + ":00";
      if (value.data.HH == "" || value.data.mm == "") {
        this.store_data.store_time[
          "store_time_open_" + days.toLowerCase() + "2"
        ] = null;
      }
    },
    selectedTimeClose2(value, days) {
      this.store_data.store_time[
        "store_time_close_" + days.toLowerCase() + "2"
      ] = value.data.HH + ":" + value.data.mm + ":00";
      if (value.data.HH == "" || value.data.mm == "") {
        this.store_data.store_time[
          "store_time_close_" + days.toLowerCase() + "2"
        ] = null;
      }
    },
    getSubDistrictAndZipCode(value) {
      this.$store.dispatch("fetchProvinceBack/getSubDistrictList", value);
      this.$store.dispatch("fetchProvinceBack/getZipCodeList", value);
    },
    getDistrict(value) {
      this.$store.dispatch("fetchProvinceBack/getDistrictList", value);
    },
    croppedLogo(image) {
      this.store_data.store_image = image;
      this.change_image = 1;
    },
    onLogoSelected(event) {
      this.selectedFile.logo_img = null;
      let file = event.target.files[0];
      this.selectedFile.logo_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.logoSrc = reader.result;
        // this.store_data.store_image = reader.result;
        this.componentsImageID = "imageCropper";
        // this.change_image = 1;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
      this.loading_progress = 0;
    },
    remove(item, index) {
      this.store_data.store_type.splice(index, 1);
      this.store_data.store_type = [...this.store_data.store_type];
    },
    setTime1() {
      this.timeCard1 = true;
    },
    setTime2() {
      this.timeCard2 = true;
    },
    selectServices(service_id) {
      this.types = [];
      for (let i in this.store_types) {
        if (this.store_types[i].store_type_service_id == service_id) {
          this.types.push(this.store_types[i]);
        }
      }
    },
    initialize() {},
  },
  watch: {
    store_data: {
      handler: async function() {},
      deep: true,
    },
    e1() {
      if (this.e1 == 5) {
      } else if (this.e1 == 2) {
        this.componentsImageID = "imageUploader";
      } else {
      }
    },
    async dialog() {
      if (this.dialog == true) {
        this.adding_store = false;
        this.store_data.store_service_charge = 0;
        this.store_data.store_vat = 0;
        // this.$refs.formStoreInformation.resetValidation();
        this.change--;
        this.change_image = 0;
        this.store_add_id = null;
        this.types = [];
      }
    },
  },
  created() {
    this.initialize();
    // this.$store.dispatch('fetchStoreBack/getStoreDetail',this.store_detail_id)
  },
};
</script>

<style>
.timePicker {
  margin-top: 15px;
}
.time-picker input.display-time {
  border: none;
}
.innerstore-timepicker {
  border: 1px solid #d2d2d2;
  width: auto;
}
.innerstore-timepicker:hover {
  border: 1px solid #333;
}

.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}

.time-picker input.display-time {
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}
/* select preorder */

.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 5px;
}

.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0;
}

.v-text-field--outline .v-input__slot {
  border-radius: 2px;
}

.v-text-field--outline .v-input__slot {
  min-height: 20px;
}

.v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0 6px;
}

.theme--light.v-text-field--outline .v-input__slot {
  border: 1px solid #d2d2d2;
}

.v-text-field--outline .v-input__slot {
  border-radius: 1px;
}
.price_range {
  font-size: 17px;
  position: absolute;
  top: 15px;
  color: #616a6b;
}
.upload_logo {
  font-size: 17px;
  position: absolute;
  top: 15px;
  color: #616a6b;
}
.upload_banner {
  font-size: 17px;
  position: absolute;
  top: 15px;
  color: #616a6b;
}

@media screen and (max-width: 981px) {
  .upload_logo {
    top: 0;
  }
}
@media screen and (max-width: 788px) {
  .upload_banner {
    top: 0;
  }
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* .my-input input{
  text-transform: uppercase
} */
</style>
